/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
import SortableList, { SortableItem } from 'react-easy-sort'
import { arrayMoveImmutable } from 'array-move'
import fileImageIcon from '../../../assets/images/file-image-icon.svg'
import closeIcon from '../../../assets/images/close.svg'
import deleteIcon from '../../../assets/images/delete.svg'
import useMediaUpload from '../../../hooks/useMediaUpload'

export const LeftSide = ({ styles, productData, handleChange, handleSpecificationChange, addSpecification, deleteSpecification, errors, setErrorMessage, errorMessage, setProductData, handleNameChange, selectedImageFileData, setSelectedImageFileData, selectedImagesValidate, setSelectedImagesValidate, setShowUploadMediaPopup, setUploadMediaPopupFor, setUploadMediaPopupTab }) => {
  const textareaRefs = useRef({});

  const [isImageDragging, setIsImageDragging] = useState(false);

  const fileList = {
    'image/jpeg': true,
    'image/png': true,
    'image/jpg': true
  };

  const { handleMeidaUpload } = useMediaUpload(setSelectedImageFileData, null, fileList);

  const autoResize = (name) => {
    const textarea = textareaRefs.current[name];
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  useLayoutEffect(() => {
    autoResize("description");
    autoResize("shortDescription");
    autoResize("seoContent");
  }, [
    productData.description,
    productData.shortDescription,
    productData.seoContent,
  ]);

  useEffect(() => {
    setProductData(prev => ({
      ...prev,
      galleryImage: selectedImageFileData?.map(item => item?.id)
    }));
  }, [selectedImageFileData]);

  const handleFileDragOver = (e) => {
    e.preventDefault();
    if (!isImageDragging) {
      setIsImageDragging(true);
    }
  }

  const handleFileDragLeave = (e) => {
    e.preventDefault();
    setIsImageDragging(false);
  };

  const onSortEnd = (oldIndex, newIndex) => {
    const updatedData = arrayMoveImmutable(selectedImageFileData, oldIndex, newIndex)
    setSelectedImageFileData(updatedData);
    setProductData(prev => ({
      ...prev,
      galleryImage: updatedData.map(item => item?.id)
    }));
  };

  const handleGalleryImageDrop = async (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    const maxSizeInBytes = 128 * 1024 * 1024; // 128MB
    const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];

    setSelectedImagesValidate(false)

    // Filter files based on type and size
    const validFiles = Array.from(files).filter(file => {
      if (!allowedFileTypes.includes(file.type)) {
        console.log(`File ${file.name} is not an allowed type. Only JPG, JPEG, and PNG are allowed.`);
        return false;
      }
      if (file.size > maxSizeInBytes) {
        console.log(`File ${file.name} exceeds the maximum size of 128MB.`);
        return false;
      }
      return true;
    });

    handleMeidaUpload(validFiles);
    setIsImageDragging(false);
  };

  const removeGalleryImage = (id) => {
    const updatedData = selectedImageFileData?.filter(item => item.id !== id);
    setSelectedImageFileData(updatedData);
    setProductData(prev => ({
      ...prev,
      galleryImage: updatedData?.map(item => item?.id)
    }));
  };

  return (
    <div className={styles.newpageLeft}>
      <div className={`${styles.newpageLeftRow} ${styles.textBlock}`}>
        <div className={`${styles.newpageLeftRow}`}>
          <div className={styles.fieldGroup}>
            <label className={styles.productInputLabel}>Title</label>
            <input
              type="text"
              name="title"
              placeholder="Enter your title"
              value={productData?.title}
              onChange={(e) => { handleNameChange(e); setErrorMessage({ ...errorMessage, title: '', slug: '' }) }}
              // onKeyDown={(e) => {
              //   changeTitle(e)
              //   setErrorMessage({ ...errorMessage, title: '', slug: '' })
              // }}
              className={styles.productInput}
            />
            {errors?.title && <p className='error-message'>{errors.title}</p>}
          </div>

          {/* Description */}
          <div className={styles.fieldGroup}>
            <label className={styles.productInputLabel}>Description</label>
            <textarea
              ref={(el) => (textareaRefs.current.description = el)}
              name="description"
              placeholder="Write your description..."
              value={productData?.description}
              onChange={handleChange}
              className={styles.descriptionTextarea}
            />
            {errors?.description && <p className='error-message'>{errors.description}</p>}
          </div>

          <div className={styles.fieldGroup}>
            <label className={styles.productInputLabel}>Short Description</label>
            <textarea
              ref={(el) => (textareaRefs.current.shortDescription = el)}
              name="shortDescription"
              placeholder="Write your short description..."
              value={productData?.shortDescription}
              onChange={handleChange}
              className={styles.descriptionTextarea}
            />
            {errors?.shortDescription && <p className='error-message'>{errors.shortDescription}</p>}
          </div>
          <div className={styles.fieldGroup}>
            <label className={styles.productInputLabel}>SEO Title</label>
            <input
              type="text"
              name="seoTitle"
              placeholder="Enter your SEO Title"
              value={productData?.seoTitle}
              onChange={(e) => { handleChange(e); setErrorMessage({ ...errorMessage, seoTitle: '' }) }}
              // onKeyDown={(e) => {
              //   changeTitle(e)
              //   setErrorMessage({ ...errorMessage, title: '', slug: '' })
              // }}
              className={styles.productInput}
            />
            {errors?.seoTitle && <p className='error-message'>{errors.seoTitle}</p>}
          </div>
          <div className={styles.fieldGroup}>
            <label className={styles.productInputLabel}>SEO Content</label>
            <textarea
              ref={(el) => (textareaRefs.current.seoContent = el)}
              name="seoContent"
              placeholder="Write your SEO content..."
              value={productData?.seoContent}
              onChange={handleChange}
              className={styles.descriptionTextarea}
            />
            {errors?.seoContent && <p className='error-message'>{errors.seoContent}</p>}
          </div>
          <div className={styles.fieldGroup}>
            <label className={styles.productInputLabel}>Keyword</label>
            <input
              type="text"
              name="keyword"
              placeholder="Enter your keyword"
              value={productData?.keyword}
              onChange={(e) => { handleChange(e); setErrorMessage({ ...errorMessage, keyword: '' }) }}
              // onKeyDown={(e) => {
              //   changeTitle(e)
              //   setErrorMessage({ ...errorMessage, title: '', slug: '' })
              // }}
              className={styles.productInput}
            />
            {errors?.keyword && <p className='error-message'>{errors.keyword}</p>}
          </div>
          <div className={styles.fieldGroup}>
            <label className={styles.productInputLabel}>Specifications</label>

            {productData?.specification?.map((item, index) => (
              <div
                key={index}
                className={styles.specification}
                style={{
                  display: "flex",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                <div>
                  <input
                    type="text"
                    placeholder="Enter label"
                    value={item.label}
                    onChange={(e) =>
                      handleSpecificationChange(index, "label", e.target.value)
                    }
                    className={styles.productInput}
                  />
                  {errors?.specification?.[index]?.label && (
                    <p className="error-message">
                      {errors.specification?.[index]?.label}
                    </p>
                  )}
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Enter value"
                    value={item.value}
                    onChange={(e) =>
                      handleSpecificationChange(index, "value", e.target.value)
                    }
                    className={styles.productInput}
                  />
                  {errors?.specification?.[index]?.value && (
                    <p className="error-message">
                      {errors.specification?.[index]?.value}
                    </p>
                  )}
                </div>
                {productData.specification.length > 1 && (
                  <button
                    onClick={() => deleteSpecification(index)}
                    className={styles.deleteButton}
                  >
                    <img src={deleteIcon} alt="delete-icon"/>
                  </button>
                )}
              </div>
            ))}

            <button
              type="button"
              onClick={addSpecification}
              className={styles.addBtn}
            >
              Add More
            </button>
          </div>

          <div className={styles.fieldGroup}>
            <label className={styles.productInputLabel}>Gallery Image</label>
            <div className={`${styles.newpageLeftRow} ${styles.textBlock} ${styles.ulpoadImageBlock}`}>
              <div className={isImageDragging ? `${styles.draging} ${styles.fileUploadBox}` : styles.fileUploadBox}
                onDragOver={handleFileDragOver}
                onDragLeave={handleFileDragLeave}
                onDrop={handleGalleryImageDrop}
              >
                <div
                  className={styles.uploadFileBlock}
                  onClick={() => {
                    setShowUploadMediaPopup(true);
                    setUploadMediaPopupFor('images-file');
                    setUploadMediaPopupTab('upload');
                  }}
                >
                  <div className={styles.featureImgMiddleContent}>
                    <img className={styles.fileUploadCover_Img} src={fileImageIcon} alt="FeaturedImage" />
                    <p className={styles.newPageImageUploadText} >
                      <span>Upload</span> or <span onClick={(e) => { e.stopPropagation(); setShowUploadMediaPopup(true); setUploadMediaPopupFor('images-file'); setUploadMediaPopupTab('media');}}>Open Image Library</span>
                      <br />
                      JPG, PNG (max. 128MB)
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {selectedImagesValidate && (
              <p className={styles.validateError}>Please choose at least one image to share</p>
            )}

            <SortableList onSortEnd={onSortEnd} className={`${styles.uploadGrid} ${styles['media-grid-layout']}`} draggedItemClassName={styles.dragged}>
              {selectedImageFileData && selectedImageFileData?.map((media) => (
                <SortableItem key={media?.id}>
                  <div className={styles.uploadItem} >
                    <div className={styles.uploadCard}>
                      {media?.isLoading ? (
                        <div className={styles.uploadPicture}>
                          <div className={styles.progressWrap}>
                            <div className={styles.progress}>
                              <div className={styles.color}></div>
                            </div>
                          </div>
                        </div>
                      ) :
                        <div className={`${styles.uploadPicture} ${styles.picture}`}>
                          <div className={styles.uploadThumbnail}>
                            <div className={styles.uploadPictureCenter}>
                              <img src={media?.url} alt={media?.name} />
                            </div>
                          </div>
                        </div>
                      }
                      <div className={styles.uploadContent}>
                        {!media?.isLoading && (
                          <>
                            <img className={styles.uploadClose} src={closeIcon} alt="icon-close" onClick={() => removeGalleryImage(media?.id)} />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </SortableItem>
              ))}
            </SortableList>
            </div>

            
          </div>
        </div>
      </div>
    )
  }
